module.exports = __webpack_public_path__ + "static/media/HCMM431.13a45cc9.jpg";